package com.ilussobsa.views

import com.ilussobsa.*
import com.ilussobsa.Strings
import com.ilussobsa.sdk.*
import com.ilussobsa.utils.*
import com.ilussobsa.views.dialogs.*
import com.lightningkite.UUID
import com.lightningkite.atZone
import com.lightningkite.kiteui.ExternalServices
import com.lightningkite.kiteui.locale.RenderSize
import com.lightningkite.kiteui.locale.renderToString
import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.navigation.dialogPageNavigator
import com.lightningkite.kiteui.navigation.pageNavigator
import com.lightningkite.kiteui.navigation.screenNavigator
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.reactive.WindowInfo
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.ViewWriter
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.l2.Recycler2
import com.lightningkite.kiteui.views.l2.RecyclerViewPlacerHorizontalGrid
import com.lightningkite.kiteui.views.l2.children
import com.lightningkite.kiteui.views.l2.icon
import com.lightningkite.lightningdb.*
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*
import com.lightningkite.uuid
import kotlin.collections.plus
import kotlin.math.max
import kotlin.math.min
import kotlin.random.Random
import kotlin.time.Duration.Companion.seconds
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.datetime.Clock.System.now

sealed class GalleryMedia {
    abstract val type: String
    abstract val location: String
}

class GalleryVehicleMedia(val media: VehicleMedia) : GalleryMedia() {
    override val type: String by media::type
    override val location: String by media.file::location
}

class GalleryDamagePhoto(val damage: Damage) : GalleryMedia() {
    override val type: String get() = ""
    override val location: String by damage.image::location
}

fun ViewWriter.vehicleInfo(selectedLot: UUID, immutable: Boolean = false, goto: suspend (vehicleId: UUID?) -> Unit) {
    val selected = remember { currentSession().vehicle[selectedLot]() }
    return vehicleInfo(selected, immutable, goto)
}

fun ViewWriter.vehicleInfo(selected: Reactive<Vehicle?>, immutable: Boolean = false, goto: suspend (vehicleId: UUID?) -> Unit) {
    val vehicle = selected
    val isBuyer = remember { selected()?.completion?.winner == currentUser()?._id }
    rowCollapsingToColumn(1400.dp) {
        atTopCenter - sizeConstraints(width = 720.dp) - col {
//                val selectedImage = Signal<Pair<ServerFile?, String>>(null to "")
//                val imageList = Signal(listOf<String>())
            val imageList = remember {
                val vehicle = vehicle.awaitNotNull()
                vehicle.media.takeIf { it.isNotEmpty() }?.let {
                    it.map { media -> GalleryVehicleMedia(media) } +
                            (vehicle.damage ?: listOf()).map { damage -> GalleryDamagePhoto(damage) }
                } ?: listOf()
            }
            val selectedImage = MutableRemember { imageList.awaitNotNull().firstOrNull() }
            sizeConstraints(
                height = 480.dp.coerceAtMost(
                    WindowInfo.value.width.minus(defaultAppTheme.gap * 2).times(2).div(3)
                )
            ) - image {
                with(rView) {
                    shown = false
                    ::shown {
                        selectedImage()?.type?.contains("video") == false
                    }
                }
                ::source {
                    selectedImage()?.location?.let(::ImageRemote)
                }
                this.description = ""
                scaleType = ImageScaleType.Crop
            }
            sizeConstraints(
                height = 480.dp.coerceAtMost(
                    WindowInfo.value.width.minus(defaultAppTheme.gap * 2).times(2).div(3)
                )
            ) - video {
                shown = false
                ::shown {
                    selectedImage()?.type?.contains("video") == true
                }
                ::source {
                    selectedImage()?.location?.let(::VideoRemote)
                }
                showControls = true
                loop = false
                scaleType = ImageScaleType.Crop
                launch {
                    volume set 0f
                    playing set false
                }
            }
            frame {
                lateinit var scroll: ScrollingBehaviors
                scrolling(horizontal = true, vertical = false) {
                    scroll = this
                } - row {
                    forEachUpdating(
                        items = remember { imageList().withIndex().toList() },
                    ) {
                        frame {
                            unpadded - button {
                                sizedBox(SizeConstraints(height = 5.rem, width = 8.rem)) - image {
                                    ::source {
                                        if (it().value.type.contains("video")) Icon.roundPlay.toImageSource(
                                            Color.gray
                                        )
                                        else it().value.location.let(::ImageRemote)
                                    }
                                    this.description = ""
                                    ::scaleType { if (it().value.type.contains("video")) ImageScaleType.Fit else ImageScaleType.Crop }
                                }
                                onClick {
                                    selectedImage.value = it().value
                                }
                            }
                        }
                    }
                }
                // Previous Button
                align(Align.Start, Align.Center) - sizeConstraints(
                    width = 3.rem,
                    height = 3.rem
                ) - card - button {
                    padding = 0.dp
                    centered - icon(
                        Icon.chevronLeft,
                        "Previous vehicle"
                    )
                    ::shown {
                        val vp = scroll.viewport()
                        val content = scroll.content()
                        (vp.left - content.left) > 20
                    }
                    onClick {
                        val vp = scroll.viewport()
                        val newVpLeft = (vp.left - 200).coerceAtLeast(scroll.content().left)
                        scroll.scrollTo(newVpLeft, vp.top, true)
                    }
                }
                // Next Button
                align(Align.End, Align.Center) - sizeConstraints(
                    width = 3.rem,
                    height = 3.rem
                ) - card - button {
                    padding = 0.dp
                    centered - icon(
                        Icon.chevronRight,
                        "Next vehicle"
                    )
                    ::shown {
                        val vp = scroll.viewport()
                        val content = scroll.content()
                        ((content.right - vp.width) - vp.left) > 20
                    }
                    onClick {
                        val vp = scroll.viewport()
                        val content = scroll.content()
                        val newVpLeft = (vp.left + 200).coerceAtMost(content.right - vp.width)
                        scroll.scrollTo(newVpLeft, vp.top, true)
                    }
                }
            }

            if (!immutable) {
                h3 {
                    ::content {
                        selected()?.statusDescription() ?: ""
                    }
                }
                vehicleActionButtons(selected, goto, isSeller)
                val lanes = remember { currentSession().auctionLane.query(Query())() }
                fieldTheme - select {
                    ::shown {
                        isSeller() &&
                        vehicle()?.let { vehicle ->
                            vehicle.submitted?.let { it < now() } == true && vehicle.completion == null
                        } == true
                    }
                    bind(
                        edits = remember {
                            selected()?.auctionLane?.let { vehicleLaneId -> lanes().find { it._id == vehicleLaneId } }
                        }.withWrite { a ->
                            val selectedLot = selected()?._id ?: return@withWrite
                            currentUserSession().vehicle[selectedLot].modify {
                                it?.copy(
                                    auctionLane = a?._id
                                )
                            }
                        },
                        data = remember { lanes() + null },
                    ) { a ->
                        if (a == null) Strings.chooseAuctionLater else Strings.auctionWithStartDate(a)
                    }
                }
                row {
                    val reserve = Signal<Int?>(null)
                    reactive {
                        reserve.value = vehicle()?.reserve
                    }
                    ::shown { isSeller() }
                    align(Align.Start, Align.Center) - bold - text(Strings.reserve1)
                    priceField(reserve) { field ->
                        val submitReserve = Action(Strings.reserve2) {
                            if (reserve.await() !== null) {
                                selected.modify(modification {
                                    it.reserve assign reserve.value
                                })
                            } else {
                                alert(Strings.error, Strings.thisFieldIsRequiredPleaseProvideAResponse)
                            }
                        }
                        field.action = submitReserve
                        ::shown { selected()?.completion == null }
                        centered - compact - unpadded - button {
                            action = submitReserve
                            gap = 0.px
                            ::enabled { reserve() != selected()?.reserve }
                            icon(Icon.done, Strings.save)
                        }
                    }
                    expanding - text {
                        ::shown { selected()?.completion != null }
                        ::content {
                            selected()?.reserve?.renderPriceInDollars() ?: "Not set"
                        }
                    }
                }

                important - row {
                    shown = false
                    ::shown {
                        isBuyer() && selected()?.let {
                            it.cancelled == null && it.archived == null && it.rerunStarted == null && it.completion?.sold == false
                        } ?: false
                    }
                    expanding - text(Strings.awaitingReview)
                }

                compact - row {
                    ::shown { isSeller() }
                    expanding - row {
                        bold - text(Strings.proxyBids1)
                        centered - text {
                            ::content {
                                val b = selected()?.autobids ?: 0
                                if (b == 0) {
                                    Strings.none
                                } else {
                                    b.toString()
                                }
                            }
                        }
                    }
                    expanding - row {
                        ::shown {
                            selected()?.completion != null && !isSeller()
                        }
                        bold - text(Strings.bids)
                        centered - text {
                            ::content{
                                (selected()?.completion?.bids ?: Strings.none).toString()
                            }
                        }
                    }
                }

                row {
                    val proxyBid = Signal<Int?>(null)
                    val existingProxyBid = remember {
                        val userId = currentUser()?._id ?: return@remember null
                        val vehicleId = selected()?._id ?: return@remember null
                        val userVehiclePair = UserVehiclePair(userId, vehicleId)
                        val vehicleRelationship = currentSession().vehicleRelationship[userVehiclePair]()
                        vehicleRelationship?.autobid
                    }
                    reactive {
                        rerunOn(selected)
                        proxyBid.value = existingProxyBid.once()
                    }
                    ::shown { selected()?.let { it.completion == null } == true && !isSeller() }
                    align(Align.Start, Align.Center) - bold - text(Strings.proxyBid)
                    priceField(proxyBid) { field ->
                        val submitProxyBid = Action(Strings.proxyBid) {
                            if (!participatesInAuctions()) {
                                dialogPageNavigator.navigate(VerificationDialog())
                            } else {
                                val selectedLot = selected()?._id ?: return@Action
                                vehicleRelationshipUpsert(selectedLot, modification {
                                    it.autobid assign proxyBid.value
                                    it.autobidBeaten assign null
                                })
                            }
                        }
                        field.action = submitProxyBid
                        centered - compact - unpadded - button {
                            gap = 0.px
                            ::shown { selected()?.liveAt == null }
                            ::enabled { proxyBid() != existingProxyBid() }
                            action = submitProxyBid
                            text {
                                ::content { if (proxyBid() != existingProxyBid()) Strings.save else Strings.saved }
                            }
                        }
                    }
                }

                row {
                    val auctionDate = remember {
                        selected()?.auctionLane?.let { currentSession().auctionLane[it]() }?.scheduledStartInstant
                    }
                    ::shown { auctionDate() != null }
                    centered - icon {
                        ::source { Icon.calendar }
                        description = "Auction date"
                    }
                    bold - centered - text {
                        ::content label@{
                            val asZoned = auctionDate()?.atZone(auctionZone) ?: return@label ""
                            buildString {
                                append(asZoned.time.renderToString())
                                append(" ")
                                append("PST")
                                append(" - ")
                                append(asZoned.date.renderToString(RenderSize.Numerical))
                            }
                        }
                    }
                }
            }
        }
        expanding - vehicleSideCard(selected)
    }
}

fun ViewWriter.vehicleSideCard(selected: Reactive<Vehicle?>) {
    val vehicle = selected
    col {
        danger- text("Details")
        compact - row {
            col {
                ::shown { selected.awaitNotNull().yearString !== null }
                WarningSemantic.onNext - text("Year")
                text {
                    ::content{ selected.awaitNotNull().yearString ?: "" }
                }
            }
        }
        compact - row {
            col {
                ::shown { selected.awaitNotNull().transmission !== null }
                WarningSemantic.onNext -  text(Strings.transmission2)
                text {
                    ::content{ selected.awaitNotNull().transmission.toString() }
                }
            }
        }
        compact - row {
            col {
                ::shown { selected.awaitNotNull().trim?.isNotEmpty() == true }
                WarningSemantic.onNext -  text(Strings.trim1)
                text {
                    ::content{ selected.awaitNotNull().trim.toString() }
                }
            }
        }

        compact - row {
            col {
                ::shown { selected.awaitNotNull().exteriorColor?.isNotEmpty() == true }
                WarningSemantic.onNext - text(Strings.exterior2)
                text { ::content{ selected.awaitNotNull().exteriorColor.toString() } }
            }
        }
        compact - row {
            col {
                ::shown { selected.awaitNotNull().interiorColor?.isNotEmpty() == true }
                WarningSemantic.onNext - text(Strings.interior2)
                text {
                    ::content{ selected.awaitNotNull().interiorColor.toString() }
                }
            }
        }
        compact - row {
            col {
                WarningSemantic.onNext - text("VIN:")
                row {
                    centered - text {
                        ::content {
                            selected.awaitNotNull().vin
                        }
                    }
                    centered - button {
                        spacing = 0.px
                        sizeConstraints(width = 1.25.rem, height = 1.25.rem) - icon {
                            source = Icon.copy
                            description = Strings.copyVINToClipboard
                        }
                        onClick { ExternalServices.setClipboardText(selected.awaitNotNull().vin) }
                    } in hintPopover(preferredDirection = PopoverPreferredDirection.belowCenter) {
                        text(Strings.copyVINToClipboard)
                    }
                }
            }
        }

        compact - row {
            col {
                WarningSemantic.onNext - text("Odometer: ")
                text {
                    ::content {
                        if (vehicle()?.odometer != null) Strings.odometerXMi(vehicle()?.odometer?.toCommaString()) else Strings.noMileageInformation
                    }
                }
            }
        }
        compact -row {
            ::shown{vehicle()?.location.toString().isNotBlank()}
            col {
                WarningSemantic.onNext -   text ("Location:")
                text {
                    ::content{ (vehicle()?.location ?: "").toString() }
                }
            }
        }
        compact - row {
            col {
                bold - danger- text("Features")
                text {
                    ::shown { vehicle()?.description != null }
                    ::content { vehicle()?.description ?: "None provided" }
                }
                italic - text {
                    ::shown { vehicle()?.description == null }
                    content = Strings.noVehicleDescriptionProvided
                }
            }
        }


    }

}

fun ViewWriter.vehicleActionButtons(
    selected: Reactive<Vehicle?>,
    goto: suspend (vehicleId: UUID?) -> Unit,
    isSeller: Reactive<Boolean>,
) {
    col {
        row {
            exists = false
            ::shown {
                isSeller() && selected()?.completion?.sold == true && selected()?.cancelled == null
            }
            compact - important - button {
                row {
                    sizeConstraints(1.5.rem, 1.5.rem) - icon(Icon.block, "")
                    centered - text(Strings.cancelTransaction)
                }
                ::shown { selected.awaitNotNull().paid == null }
                onClick {
                    dialogPageNavigator.navigate(
                        GenericConfirmationDialog(
                            message = Strings.cancelTransactionConfirmation,
                            confirmMessage = Strings.confirm,
                            onConfirm = {
                                selected.modify(modification {
                                    it.cancelled assign now()
                                    it.cancellationReason assign CancellationReason.OFFER_DECLINED
                                    it.completion assign selected()?.completion?.copy(sold = false)
                                })
                            }
                        )
                    )
                }
            }
        }
        row {
            shown = false
            ::shown {
                selected.awaitNotNull()
                    .let { it.completion?.winner != null && it.completion?.sold == false && it.cancelled == null && isSeller() }
            }
            compact - important - button {
                compact - row {
                    sizeConstraints(1.5.rem, 1.5.rem) - icon(Icon.close, Strings.decline)
                    centered - text(Strings.decline)
                }
                onClick {
                    selected.modify(modification {
                        it.cancelled assign now()
                        it.cancellationReason assign CancellationReason.OFFER_DECLINED
                    })
                }
            }
            compact - important - button {
                compact - row {
                    sizeConstraints(1.5.rem, 1.5.rem) - icon(Icon.done, Strings.accept)
                    centered - text(Strings.accept)
                }
                onClick {
                    val selectedLot = selected()?._id ?: return@onClick
                    currentUserSession().uncached.vehicle.acceptInitialOffer(selectedLot)
                    currentUserSession().vehicle.localSignalUpdate(
                        matching = { it._id == selectedLot },
                        modify = {
                            it.copy(
                                completion = it.completion!!.copy(
                                    at = now(),
                                    sold = true,
                                )
                            )
                        }
                    )
                }
            }
        }
        row {
            row {
                exists = false
                ::shown {
                    selected.awaitNotNull()
                        .let { it.completion?.sold == true && it.completion?.winner == currentUser()?._id }
                }
                compact - important - button {
                    row {
                        sizeConstraints(1.5.rem, 1.5.rem) - icon(Icon.done, "")
                        centered - text(Strings.vehicleReceived)
                    }
                    ::shown { selected.awaitNotNull().received == null }
                    onClick {
                        currentSession().vehicle.get(selected.awaitNotNull()._id)
                            .modify(modification {
                                it.received assign now()
                            })
                    }
                } //done
            }
            row {
                exists = false
                ::shown {
                    selected.awaitNotNull()
                        .let { isSeller() && it.completion?.sold == true }
                }
                compact - important - button {
                    row {
                        sizeConstraints(1.5.rem, 1.5.rem) - icon(Icon.done, "")
                        centered - text(Strings.paymentReceived)
                    }
                    ::shown { selected.awaitNotNull().paid == null }
                    onClick {
                        currentSession().vehicle.get(selected.awaitNotNull()._id)
                            .modify(modification {
                                it.paid assign now()
                            })
                    }
                } //done diff
            }
            compact - important - button {
                compact - row {
                    icon(Icon.sync, Strings.rerunInTheUpcomingWeek)
                    centered - text(Strings.rerunInTheUpcomingWeek)
                }
                exists = false
                ::shown {
                    selected()
                        .let { it?.completion?.sold == false && isSeller() && it.cancelled != null && it.rerunStarted == null }
                }
                onClick {
                    val selectedLot = selected()?._id ?: return@onClick
                    currentUserSession().vehicle.get(selectedLot).modify(modification {
                        it.rerunStarted assign now()
                    })
                    currentUserSession().vehicle.insert(
                        selected.awaitNotNull().copy(
                            _id = uuid(),
                            submitted = now(),
                            liveAt = null,
                            completion = null,
                            paid = null,
                            received = null,
                            cancelled = null,
                            rerunStarted = null,
                            auctionLane = null,
                        )
                    )
                    goto(null)
                }
            }  //rerun
            compact - important - button {
                exists = false
                ::shown {
                    isSeller() && selected()?.liveAt == null && selected()?.completion == null
                            && selected()?.archived == null
                }
                centered - text(Strings.updateListing)
                onClick {
                    val selectedLot = selected()?._id ?: return@onClick
                    if ((selected.await()?.autobids ?: 0) == 0) this.pageNavigator.navigate(
                        EditVehicleScreen(selectedLot).apply {
                            flowMode.value = false
                        }
                    )
                    else dialogPageNavigator.navigate(ConfirmUpdateListing(selectedLot))
                }
            }
            compact - important - button {
                exists = false
                ::shown{
                    isSeller()
                            && selected()?.submitted == null
                            && selected()?.archived == null
                }
                centered - text(Strings.submitToAuction)
                onClick {
                    val selectedLot = selected()?._id ?: return@onClick
                    val v = currentSession().vehicle.get(selectedLot)
                    val v2 = v() ?: return@onClick
                    EditVehicleScreen.Tab.values().firstOrNull { it.ready(v2) != EditStatus.Complete }?.let {
                        screenNavigator.navigate(EditVehicleScreen(v2._id))
                    } ?: v.modify(modification { it.submitted assign now() })
                }
            }
            compact - danger - button {
                exists = false
                ::shown {
                    isSeller() && selected()
                        ?.let { it.liveAt == null && it.completion == null && it.submitted != null } == true
                }
                centered - text(Strings.unlist)
                onClick {
                    selected.modify(modification { it.submitted assign null })
                }
            }
            compact - danger - button {
                exists = false
                ::shown {
                    isSeller() && selected()
                        ?.let { it.submitted == null || it.cancelled != null } == true
                }
                centered - text {
                    ::content { if (selected()?.archived == null) Strings.archive else Strings.unarchive }
                }
                onClick {
                    selected.modify(modification { it.archived assign (if (selected()?.archived == null) now() else null) })
                }
            }
            important - compact - button {
                ::shown {
                    selected()?.liveAt == null && selected()?.completion == null
                            && selected()?.archived == null && (currentUser()?.role ?: UserRole.Anonymous) >= UserRole.UnverifiedCustomer
                }
                onClick {
                    dialogPageNavigator.navigate(
                        SendEmailDialog(
                            onConfirm = { message ->
                                val selectedLot = selected()?._id ?: return@SendEmailDialog
                                currentUserSession().uncached.vehicle.sendInquiryEmail(
                                    id = selectedLot,
                                    input = VehicleInquiry(
                                        question = message
                                    )
                                )
                            }
                        ))
                }
                centered - text(Strings.inquire)
            }
        }
    }
}

private suspend fun Reactive<Vehicle?>.modify(modification: Modification<Vehicle>) {
    currentUserSessionNullable()!!.vehicle.get(awaitNotNull()._id).modify(modification)
}

fun ViewWriter.vehicleBuyer(vehicle: Reactive<Vehicle?>) =
    vehicleBuyerInfo(remember { vehicle()?.completion?.winner })

fun ViewWriter.vehicleBuyerInfo(
    buyer: Reactive<UUID?>
) {
    card - col {
        exists = false
        ::shown { buyer() != null }
        h2 { content = Strings.auctionWinner }
        rowCollapsingToColumn(70.rem) {
//                if (screenNavigator == dialogPageNavigator) {
//                    onNavigator = dialogPageNavigator
//                    ::to { val id = buyer; { SellingDialogWrapper(ProfileScreen(id))}}
//                } else {
//                    ::to { val id = buyer; { ProfileScreen(id)}}
//                }
            contactInfo(Strings.buyer, remember { currentSession().user[buyer.awaitNotNull()].awaitNotNull() })
        }
    }
}

fun ViewWriter.vehicleWinner(selected: Reactive<Vehicle?>) {
    /*val winner = remember {
        val sel = selected() ?: return@remember null
        if (sel.seller == currentDealershipId())
            sel.completion?.winner?.let { currentSessionNullable.awaitNotNull().dealerships[it] }?.await()
        else null
    }
    vehicleContactInfo({ if (selected()?.completion?.sold == true) Strings.buyer else Strings.auctionWinner }, winner)*/
}